import { type Editor, Extension, type KeyboardShortcutCommand } from '@tiptap/core';

export interface SubmitShortcutOptions {
  onSubmit: () => void;
  enterToSubmit: boolean;
  /** Lets the host give Enter back to whatever it has open (e.g. a paste menu). */
  shouldYieldEnter: (editor: Editor) => boolean;
}

export const SubmitShortcut = Extension.create<SubmitShortcutOptions>({
  name: 'submitShortcut',

  addOptions() {
    return {
      onSubmit: () => {},
      enterToSubmit: false,
      shouldYieldEnter: () => false,
    };
  },

  addKeyboardShortcuts() {
    const submit = () => {
      this.options.onSubmit();
      return true;
    };

    const shortcuts: Record<string, KeyboardShortcutCommand> = { 'Mod-Enter': submit };

    if (this.options.enterToSubmit) {
      // This extension registers later than the rest, so it wins conflicting
      // keymaps — yielding is the only way for Enter to fall through.
      shortcuts.Enter = () => {
        if (this.options.shouldYieldEnter(this.editor)) return false;
        return submit();
      };
    }

    return shortcuts;
  },
});
